import { CSSProperties, forwardRef, PropsWithChildren } from 'react';

import { PanelContext } from './PanelContext';
import { PanelInstanceContext } from './PanelInstanceContext';
import { v4 } from '../common/uuid';
import clsx from 'clsx';

export interface PanelInlineProps {
  title: string;
  className?: string;
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
}

export const PanelInline = forwardRef<HTMLDivElement, PropsWithChildren<PanelInlineProps>>(function PanelInline(
  { title, className, width, height, children },
  ref,
) {
  return (
    <PanelContext.Provider value={{ resizeable: false, resizePanel: () => {}, initialResizePanel: () => {} }}>
      <PanelInstanceContext.Provider
        value={{
          setTitle: () => {},
          title,
          zIndex: 1500,
          uniqueId: v4(),
          dock: () => {},
          panelClose: () => {},
          dockId: undefined,
          docked: false,
          bringPanelToFront: () => {},
          hidden: false,
          setPanelWindow: () => {},
          panelTogglePopout: () => {},
          undock: () => {},
          panelPoppedOut: false,
          bounds: undefined,
        }}
      >
        <div ref={ref} className={clsx('WindowPanel', className)} title={title} style={{ width, height }}>
          {children}
        </div>
      </PanelInstanceContext.Provider>
    </PanelContext.Provider>
  );
});
